export const MY_TASK_PAGE_DATAGRID_STATE_STORAGE_KEYS = {
  ACTIVE_TASKS_TAB: "my-tasks-page-active-tasks-tab-datagrid-storage-key_v1",
  COMPLETED_AND_CANCELED_TASKS_TAB:
    "my-tasks-page-completed-and-canceled-tasks-tab-datagrid-storage-key_v1",
};
export const MY_TASK_PAGE_TABS = {
  ACTIVE_TASKS_TAB: "ACTIVE_TASKS_TAB",
  COMPLETED_AND_CANCELED_TASKS_TAB: "COMPLETED_AND_CANCELED_TASKS_TAB",
};
export const MY_TASKS_STORAGE_KEYS = {
  IS_INCLUDE_CANCELED_TASKS: "is-include-canceled-tasks-key",
  CANCELED_TASKS_MONTH_RANGE: "canceled-tasks-month-range-key",
  IS_INCLUDE_COMPLETED_TASKS: "is-include-completed-tasks-key",
  COMPLETED_TAKS_MONTH_RANGE: "completed-tasks-month-range-key",
  IS_ACTIVE_TASK_TAB_IN_LIST_VIEW_MODE:
    "is-active-tasks-tab-in-list-view-mode-key",
};
export const CHECK_COMPLETED_OR_CANCELED_CHECKBOX_MESSAGE = `Both checkboxes above are currently unchecked. \n You will not see any tasks here unless one of the checkboxes are selected.`;
export const NO_COMPLETED_OR_CANCELED_TASKS_MESSAGE = `You have no completed or canceled tasks that fall within the timeframe selected above. \n\n If you are looking for a specific tasks, consider increasing the lookback period above.`;
export const NO_COMPLETED_TASKS_MESSAGE = `You have no completed tasks that fall within the timeframe selected above. \n\n If you are looking for a specific tasks, consider increasing the lookback period above.`;
export const NO_CANCELED_TASKS_MESSAGE = `You have no canceled tasks that fall within the timeframe selected above. \n\n If you are looking for a specific tasks, consider increasing the lookback period above.`;
export const NO_TASKS_MESSAGE_FOR_EXTERNAL_USER = `You have no tasks assigned to you.  \n\n 
New tasks will appear here once they have been assigned. \n\n 
You will receive an email notification whenever a new task is assigned to you.`;
export const NO_TASKS_MESSAGE_FOR_NORMAL_USER = `You have no tasks assigned to you.  \n\n 
New tasks will appear here once they have been assigned. \n\n 
You can view any tasks you have already completed by clicking on the "Completed & Canceled Tasks" tab above.`;

export const MY_TASK_STATE_STORAGE_KEY = "MyTaskStorage";
